export default __webpack_public_path__ + "static/media/full_screen_light.b86308d8.svg";